// src/common/hooks/useAutoLogin.ts
import { useEffect, useRef } from "react";
import { getApi } from "../../api/api";
import { useEnvironmentDetect } from "./useEnvironmentDetect";

export const useAutoLogin = () => {
  const { isTelegramMiniApp } = useEnvironmentDetect();
  const attempted = useRef(false);

  useEffect(() => {
    if (!isTelegramMiniApp || attempted.current) return;
    attempted.current = true;

    const initData = window.Telegram?.WebApp?.initData;
    if (!initData) return;

    const api = getApi();
    api.botLogin({ initData }).catch((error) => {
      console.debug("Auto login failed", error?.message);
    });
  }, [isTelegramMiniApp]);
};
